<template>
  <div class="sidenav-container" :class="{ darken : sideNavOnWhite }">
    <div class="side-nav" ref="sideNav">
      <div
        class="nav-label-container"
        :class="{show: navLabelActive}"
        :style="[ isIE ? { top: '-25px', transformOrigin: 'left center' } : {} ]"
      >
        <span class="nav-label" v-html="navLabelText"></span>
      </div>
      <ul>
        <li v-for="(link, index) in this.links">
          <router-link
            :to="'/report/' + index" class="side-nav-button"
            :class="{active: sideNavActiveIdx === index}"
            :data-idx="index"
            v-on:click.native="updateActive"
            v-on:mouseover.native="showLabel"
            v-on:mouseleave.native="hideLabel"
          >
            <span></span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import StateMixin from '@/components/report/mixins/StateMixin'

  export default {
    name: 'SideNavigation',
    data () {
      return {
        links: [
          'Introduction',
          'Strategize',
          'Build',
          'Acquire',
          'Analyze',
          'Engage',
          'Optimize',
          'Conclusion'
        ],
        navLabelText: 'INTRO',
        navLabelActive: false
      }
    },
    mixins: [ StateMixin ],
    methods: {
      getIdx ( e ) {
        return e.target.getAttribute( 'data-idx' )
      },
      updateActive ( e ) {
        this.$store.dispatch( 'setSideNavActiveIdx', parseInt( this.getIdx( e ) ) )
      },
      showLabel ( e ) {
        this.navLabelText = this.links[ this.getIdx( e ) ]
        this.navLabelActive = true
      },
      hideLabel () {
        this.navLabelActive = false
      }
    },
    created () {
      let reportNum = this.$route.params.idx
      this.activeIdx = parseInt( reportNum )
    },
    mounted () {
      this.$store.dispatch( 'setSideNavHeight', this.$refs.sideNav.offsetHeight )
    }
  }
</script>

<style lang="scss">
  @import '../../assets/scss/global/the_goods';

  $sideNavWidth : 41px;
  $sideNavRadius : $sideNavWidth / 2;

  .sidenav-container {
    position    : fixed;
    left        : 20px;
    top         : 0;
    height      : 100%;
    display     : flex;
    align-items : center;
    z-index     : 101;

    .side-nav {
      width          : $sideNavWidth;
      background     : white;
      border-radius  : $sideNavRadius;
      display        : flex;
      flex-direction : column;
      align-items    : center;
      position       : relative;
      border         : solid 1px #eee;
      opacity        : 0;
      transition     : opacity 1s;

      body.show-gnav & {
        opacity : .9;
      }

      ul {
        padding : 0;
        margin  : 0;
      }

      li {
        position        : relative;
        width           : 24px;
        height          : 27px;
        display         : flex;
        justify-content : center;
        align-items     : center;

        &:first-of-type {
          margin-top : 10px;
        }

        &:last-of-type {
          margin-bottom : 10px;
        }
      }

      .side-nav-button {
        position        : relative;
        display         : flex;
        justify-content : center;
        align-items     : center;
        border-radius   : 50%;
        padding         : 5px;
        height          : 100%;
        width           : 100%;

        span {
          width         : 6px;
          height        : 6px;
          background    : black;
          display       : block;
          border-radius : 50%;
        }

        &:after {
          content       : '';
          display       : block;
          width         : 24px;
          height        : 24px;
          position      : absolute;
          border        : 2px solid black;
          border-radius : 50%;
          transform     : scale(0);
          transition    : transform .3s;
          top           : 1px;
          left          : 0;
        }

        &.active {
          &:after {
            transform : scale(1);
          }

          &:hover {
            &:after {
              transform : scale(1);
            }
          }
        }

        &:hover {
          &:after {
            transform : scale(0.7);
          }
        }
      }

      .nav-label-container {
        position       : absolute;
        top            : -85px;
        transform      : rotate(-90deg) translateX(5px);
        color          : white;
        letter-spacing : .3em;
        font-size      : 12px;
        pointer-events : none;
        transition     : opacity .2s, transform .2s, color .2s;
        width          : 120px;
        opacity        : 0;

        .nav-label {
          text-align     : left;
          text-transform : uppercase;
          font-weight    : 700;
        }

        &.show {
          opacity   : 1;
          transform : rotate(-90deg) translateX(0px);
        }
      }
    }

    &.darken {
      .side-nav {
        .nav-label-container {
          color : black;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/sideNav.vue